var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.isBatchRefundShow, width: "30%" },
      on: {
        "update:visible": function ($event) {
          _vm.isBatchRefundShow = $event
        },
      },
    },
    [
      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(
          _vm._s(
            _vm.orderNumberList.length <= 1
              ? _vm.$t("after-sales::after-sale-list::detail_refund_weather") +
                  "？"
              : _vm.$t(
                  "after-sales::after-sale-list::detail_sales_order_refund_weather"
                ) + "?"
          )
        ),
      ]),
      _c("span", [
        _vm._v(
          _vm._s(
            _vm.$t("after-sales::after-sale-list::detail_sales_order_num")
          ) + ":"
        ),
      ]),
      _vm._l(_vm.orderNumberList, function (item, index) {
        return _c(
          "span",
          { key: index, staticStyle: { "margin-bottom": "20px" } },
          [
            _vm._v(" " + _vm._s(item) + " "),
            index < _vm.orderNumberList.length - 1
              ? _c("span", [_vm._v("、")])
              : _vm._e(),
          ]
        )
      }),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t("after-sales::after-sale-list::detail_auto_refund_warning")
          ) + "!"
        ),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.close } }, [
            _vm._v(
              _vm._s(_vm.$t("after-sales::after-sale-list::detail_btn_cancel"))
            ),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submitConfirm } },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("after-sales::after-sale-list::detail_btn_confirm")
                )
              ),
            ]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }